<template>
	<textarea
		class="afizolo"
		:class="[size, status, resize]"
		:value="value"
		:rows="rows"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
		@input="$emit('input', $event.target.value)"
		:data-fup="`input/${id}`"
	/>
</template>

<script>
export default {
	name: "j-base-input-long-text",
	props: {
		id: String,
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		rows: {
			required: false,
			default: 10,
			validator(val) {
				return val === null || typeof val === "number"
			}
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		resize: {
			required: false,
			default: ""
		}
	}
}
</script>
<style src="./index.css" scoped />